import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { RepaymentsService } from 'app/services/repayments.service';
import { FileUploader } from 'ng2-file-upload';
import * as uuid from 'uuid';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { LoanappService } from './../../services/loanapp.service';
declare var $: any;
@Component({
  selector: 'app-loan-repayment',
  templateUrl: './loan-repayment.component.html',
  styleUrls: ['./loan-repayment.component.css'],
})
export class LoanRepaymentComponent implements OnInit {
  public errMessage: string = '';
  noOfBagsForRepayment: any;
  invalidnoOfBags: boolean = false;
  invalidnoOfBagsMessage: string = '';
  amountThatWillbeRepaid: any;
  loansAmountToBagRatio: any;
  bagsBalance: number;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  appId: String;
  uId: String;
  pageType: String;
  appdetails: any;
  dataRec: any;
  insDetails: any;
  dataToShow: any;
  isReadOnly: Boolean = true;
  farmerDetails: any;
  statess = true;
  ifUpdated: Boolean = false;
  saveBtn: Boolean = false;
  InsuranceDetails: Boolean = false;
  perUnitValue: any = '';
  totalMarketValue: any = '';
  unit: any = '';
  updateBtn: String = 'Update';
  showNoDetails: Boolean = false;
  qunit: any;
  imgPath: any;
  fieldEmptyh: Boolean = false;
  approveBtnClicked: Boolean = false;
  noDocument: Boolean = false;
  qrCode: Boolean = false;
  receiptG: Boolean = false;
  myAngularxQrCode: string = null;
  user: any;
  baseURI = this.auth.baseURL; // 'https://warehouses.whrrl.in';
  loanReq: Boolean = false;
  deliveryBags: any;
  deliveryQuantity: any;
  deliveryData: any;
  deliveryvalue: number;
  totalnumberOfbagsDelivered: any;
  totalQuantityDelivered: any;
  deliveryQuantityRemaining: number;
  deliveryBagsRemaining: number;
  error: string;

  image: File;
  uploadStatus: any;
  loanDetails: any;
  offlineLoan: boolean = false;
  principal: any;
  issuerName: any;
  installmentAmt: Number = 0;
  interest: Number = 0;
  nocDate: any;
  nocFile: any;
  repaymentAmt: any;
  repaymentPercentage: any;
  lienFreeQuantity: number;
  perBagWeight: number;
  lienFreeBags: number;
  fileUpload: any;
  baseURL: string;
  URL: string;
  wdepositDetails: any;
  repaymentData: any;
  balanceAmount: number;
  submittingRepayment: boolean = false;
  invalidPrincipalAmount: boolean = false;
  invalidPrincipalAmountMessage: string = '';
  remark: string = '';
  constructor(
    private activatedRoute: ActivatedRoute,
    private auth: AuthService,
    private router: Router,
    private rService: RepaymentsService,
    private toastr: ToastrService,
    private http: HttpClient,
    private lservice: LoanappService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.baseURL = this.auth.baseURL;
      this.appId = params['id'];
      this.uId = params['uId'];
      this.pageType = params['p'];
      this.loanReq = params['loanReq'];
      if (this.pageType) {
        this.showNoDetails = true;
      } else {
        this.showNoDetails = false;
      }
    });
  }

  ngOnInit() {
    this.user = this.auth.user;
    this.getRepaymentById();
    this.getData();
  }

  checkRepaymentAmount() {
    if (this.balanceAmount <= 0) {
      this.invalidPrincipalAmount = true;
      this.invalidPrincipalAmountMessage = `Repayed 100% loan amount`;
      return;
    } else if (!this.principal) {
      this.invalidPrincipalAmount = true;
      this.invalidPrincipalAmountMessage = `Please provide principal amount`;
      return;
    } else if (
      parseFloat(this.principal) > this.balanceAmount ||
      parseFloat(this.principal) < 1
    ) {
      this.invalidPrincipalAmount = true;
      this.invalidPrincipalAmountMessage = `Principal amount must be in range 1-${this.balanceAmount}`;
      return;
    } else {
      this.invalidPrincipalAmount = false;
      this.invalidPrincipalAmountMessage = '';
      return;
    }
  }

  checkNoOfBagsToBeRepaid() {
    console.log(this.noOfBagsForRepayment);
    console.log(this.bagsBalance);
    if (this.bagsBalance <= 0) {
      this.invalidnoOfBags = true;
      this.invalidnoOfBagsMessage = `Repayed 100%;`;
      return;
    } else if (!this.noOfBagsForRepayment) {
      this.invalidnoOfBags = true;
      this.invalidnoOfBagsMessage = `Please Enter No of Bags.`;
      return;
    } else if (
      parseFloat(this.noOfBagsForRepayment) > this.bagsBalance ||
      parseFloat(this.noOfBagsForRepayment) < 1
    ) {
      this.invalidnoOfBags = true;
      this.invalidnoOfBagsMessage = `No of Bags must be in range 1-${this.bagsBalance}`;
      return;
    } else {
      this.amountThatWillbeRepaid =
        this.loansAmountToBagRatio * this.noOfBagsForRepayment;
      this.principal = this.amountThatWillbeRepaid;
      this.invalidnoOfBags = false;
      this.invalidnoOfBagsMessage = '';

      return;
    }
  }

  async getData() {
    this.rService.getRepayment(this.appId, this.uId).subscribe(
      (data) => {
        this.dataRec = true;

        if (data['success']) {
          this.appdetails = data['data'];
          this.dataToShow = data['data'];
          this.farmerDetails = data['user'];
          this.insDetails = data['insD'];
          this.loanDetails = data['loanDetails'];
          this.repaymentAmt = data['repaymentAmt'];
          this.repaymentPercentage = data['repaymentPercentage'].toFixed(2);
          this.perBagWeight =
            this.appdetails['depositQty'] / this.appdetails['noOfBags'];
          if (this.insDetails) {
            if (this.insDetails['document'][0] != '') {
              this.noDocument = true;
            }
          }

          // Balance amount for repayment
          this.balanceAmount =
            parseFloat(this.loanDetails.approved.loanAmount) -
            (parseFloat(this.repaymentAmt) || 0);
          this.loansAmountToBagRatio =
            parseFloat(this.loanDetails.approved.loanAmount) /
            Number(this.appdetails['noOfBags']);

          this.totalMarketValue = this.appdetails['totalMarketValue'];
          this.perUnitValue = this.appdetails['perUnitValue'];
          this.unit = this.appdetails['unit'];
          this.updateBags();
          if (this.loanDetails) {
            if (this.loanDetails['applicationType'] == 'offlineLoan') {
              this.offlineLoan = true;
            }
          }
        } else {
          // return false;
          this.toastr.warning('Something went wrong, please try again');
        }
      },
      (err) => {
        console.log(err);

        this.errMessage = 'Bad request';
        this.toastr.error('Data incorrect, please try again.');
        $('#error').modal('show');
      }
    );
  }

  repayment() {
    this.submittingRepayment = true;

    let Data = {
      loanId: this.loanDetails._id,
      // principal: this.principal,
      bags: this.noOfBagsForRepayment,
      remark: this.remark
    };

    this.rService.addRepaymentDetails(Data).subscribe(
      (data) => {
        // this.principal = null;
        this.noOfBagsForRepayment = null;
        this.amountThatWillbeRepaid = null;
        this.submittingRepayment = false;

        if (data['success']) {
          $('#accept').modal('hide');
          $('#approved').modal('show');
          this.repaymentData = data['data'].repaymentData;
          this.repaymentAmt = data['data'].repaymentAmt;
          this.repaymentPercentage = data['data'].repaymentPercentage.toFixed(
            2
          );
          this.appdetails.lienStatus = data['data'].lienStatus;
          this.balanceAmount =
            parseFloat(this.loanDetails.approved.loanAmount) -
            (parseFloat(this.repaymentAmt) || 0);
          this.updateBags();
        }
      },
      (err) => {
        console.log(err);
        this.submittingRepayment = false;
        $('#accept').modal('hide');
        $('#error').modal('show');
      }
    );
  }

  updateBags() {
    if (this.appdetails['lienStatus']) {
      console.log('Lien Status Found #####################');
      this.lienFreeQuantity =
        this.appdetails['depositQty'] * (this.repaymentPercentage / 100);

      this.lienFreeBags = Math.trunc(this.lienFreeQuantity / this.perBagWeight);
    } else {
      console.log('No Lien Status #####################');
      this.lienFreeQuantity = this.appdetails['depositQty'];
      this.lienFreeBags = Math.trunc(this.lienFreeQuantity / this.perBagWeight);
    }

    console.info('Bags', this.lienFreeQuantity / this.perBagWeight);
    this.bagsBalance = this.appdetails['noOfBags'] - this.lienFreeBags;
    console.log('No of bags to be repaid = ' + this.bagsBalance);

    // this.deliveryBagsRemaining =
    //   Number(this.lienFreeBags) - Number(this.totalnumberOfbagsDelivered);
    // this.deliveryQuantityRemaining =
    //   this.lienFreeQuantity - this.totalQuantityDelivered;

    // // console.log(this.deliveryBagsRemaining, this.deliveryQuantityRemaining);
    // this.deliveryBags = this.deliveryBagsRemaining;
    // this.deliveryQuantity = this.deliveryQuantityRemaining;

    // if (
    //   this.deliveryBags > this.deliveryBagsRemaining ||
    //   this.deliveryBagsRemaining == 0
    // ) {
    //   if (this.deliveryBagsRemaining == 0) {
    //     this.error = 'No bags for delivery.';
    //     // this.getData();
    //   } else this.error = 'Invalid number of bags.';
    // }
  }

  // onChange() {
  //   // console.log(this.deliveryBags, this.deliveryBagsRemaining);
  //   if (this.deliveryBags >= this.deliveryBagsRemaining) {
  //     this.deliveryBags = this.deliveryBagsRemaining;
  //     this.deliveryQuantity = this.deliveryQuantityRemaining;
  //     this.deliveryQuantity =
  //       (this.appdetails.depositQty / this.appdetails.noOfBags) *
  //       this.deliveryBags;
  //     this.deliveryvalue =
  //       this.deliveryQuantity * this.appdetails['perUnitValue'];
  //   } else {
  //     this.deliveryQuantity =
  //       (this.appdetails.depositQty / this.appdetails.noOfBags) *
  //       this.deliveryBags;
  //     this.deliveryvalue =
  //       this.deliveryQuantity * this.appdetails['perUnitValue'];
  //   }
  // }

  getRepaymentById() {
    this.rService.getRepaymentById(this.appId).subscribe(
      (data) => {
        if (data['success']) {
          this.repaymentData = data['data'].repaymentData;
        }
      },
      (err) => {
        console.log(err);
        this.errMessage = 'Data not found';
        // this.toastr.error("Data not found, please try again!");
        console.log(this.errMessage);
        // $('#error').modal('show')
      }
    );
  }

  loanType(value) {
    // console.log(value);
    if (value == 'offlineLoan') return 'Offline lien creation ';
    else return 'Online lien creation ';
  }

  // submitProfile() {
  //   if (this.isReadOnly) {
  //     this.updateBtn = 'Cancel';
  //   } else {
  //     this.updateBtn = 'Update';
  //   }
  //   this.isReadOnly = !this.isReadOnly;
  //   this.statess = !this.statess;
  //   this.ifUpdated = !this.ifUpdated;
  // }

  addInsurance() {
    window.location.href =
      '/addinsurance?id=' + this.appId + '&uId=' + this.farmerDetails['_id'];
  }
  // delivaryAccept() {
  //   if (
  //     this.deliveryBags > this.deliveryBagsRemaining ||
  //     this.deliveryBagsRemaining == 0
  //   ) {
  //     if (this.deliveryBagsRemaining == 0) this.error = 'No bags for delivery.';
  //     else this.error = 'Invalid number of bags.';
  //   } else $('#delivaryAccept').modal('show');
  // }

  // delivaryCancelaccept() {
  //   $('#delivaryAccept').modal('hide');
  // }
  accept() {
    if (!this.principal) {
      this.invalidPrincipalAmountMessage = 'Please provide principal amount';
      this.invalidPrincipalAmount = true;
      return;
    } else {
      this.invalidPrincipalAmountMessage = null;
      this.invalidPrincipalAmount = false;
    }

    this.submittingRepayment = false;
    $('#accept').modal('show');
  }

  cancelaccept() {
    $('#accept').modal('hide');
  }
  reject() {
    $('#reject').modal('show');
  }

  cancelreject() {
    $('#reject').modal('hide');
  }

  approve() {
    if (!this.isEmpty(this.appdetails)) {
      this.fieldEmptyh = true;
      let self = this;
      setTimeout(() => {
        self.fieldEmptyh = false;
      }, 3000);
    } else {
      $('#approve').modal('show');
    }
  }

  isEmpty(obj: any) {
    for (let v in obj) {
      if (obj[v] === undefined) {
        return false;
      }
    }
    return true;
  }

  cancelapprove() {
    $('#approve').modal('hide');
  }

  // seeReceipt() {
  //   // this.router.navigateByUrl('/receipt?appId=' + this.appId + '&uId=' + this.farmerDetails['_id'])
  //   let elem: HTMLElement = document.getElementById('generateReceipt');
  //   elem.click();
  // }

  // cancel() {
  //   window.location.href = '/depositapplications';
  // }

  // qrCodee() {
  //   this.receiptG = false;
  //   this.qrCode = true;
  // }

  // print(cmpName) {
  //   let printContents = document.getElementById(cmpName).innerHTML;
  //   let originalContents = document.body.innerHTML;
  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // }

  // reC() {
  //   this.receiptG = true;
  //   this.qrCode = false;
  // }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

  // borrowerConsent() {
  //   this.router.navigateByUrl(
  //     '/borrower-consent?bankId=banlId&whReceiptId=' + this.appdetails['_id']
  //   );
  // }
}
